import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d178e854"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "instructions" }, " Select a queue from the drop-down list and view all of the agents' status in real-time. ", -1))
const _hoisted_3 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QueueSelector = _resolveComponent("QueueSelector")!
  const _component_QueueDetails = _resolveComponent("QueueDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_QueueSelector, { onQueueSelected: _ctx.onQueueSelected }, null, 8, ["onQueueSelected"]),
      _createVNode(_component_QueueDetails, { queue: _ctx.queue }, null, 8, ["queue"])
    ])
  ]))
}